<template>
	<vue-topprogress ref="topProgress" :maximum="maxTopProgress" :trickleSpeed="trickleSpeed"></vue-topprogress>
</template>

<script>
import { vueTopprogress } from 'vue-top-progress'
import { Message, Loading } from 'element-ui'
import has from 'has'

let $topProgress = null
let $comp = null

let loadingContext = {
	upgradTimer: null,
	loading: null,
	counter: 0,
	/**
	 * 0- 初始状态，
	 * 1- 正在加载，
	 * 2- 轻加载，
	 * 3- 重加载
	 */
	state: 0,
	targets: {}
}

const DEFAULT_LIGHT_PROMPT_TRIGGER = 500
const DEFAULT_HEAVEY_PROMPT_TRIGGER = 5000
const ERROR_MESSAGE_DURATION = 5 * 1000

/**
 * @param target { string? } Loading加载对象，对应Loading的target参数,另外调用计数也区分开来。不指定的话，默认使用'_GLOABAL_'，Loading加载在全屏幕
 * @param topProgressDuration { number? } 顶部小loading的时常，默认300ms，超过了转为大loading
 * @param heavyTrigger { number? } 大loading时长，默认5000ms
 * 非全屏幕的时候，直接转loading
 * 全屏幕的时候，响应时间快的走topProgress，超了转loading
 */
function start(target, lightTrigger, heavyTrigger) {
	if (target === undefined || target === null) target = '_GLOBAL_'
	if (lightTrigger === undefined) lightTrigger = DEFAULT_LIGHT_PROMPT_TRIGGER
	if (heavyTrigger === undefined) heavyTrigger = DEFAULT_HEAVEY_PROMPT_TRIGGER

	/** @type { typeof loadingContext | null } */
	let lContext = null
	/** 是否温馨提示 */
	let canLightPrompt = false

	if (target == '_GLOBAL_') {
		lContext = loadingContext
		canLightPrompt = true
	} else {
		if (!has(loadingContext.targets, target)) {
			loadingContext.targets[target] = {
				upgradTimer: null,
				counter: 0,
				state: 0,
				loading: null
			}
		}

		lContext = loadingContext.targets[target]
	}

	/**
	 * @param timeout { number } 计时器触发时长
	 * @param context { typeof loadingContext } 加载器上下文
	 */
	let fnPendingUpgradeToLightPrompt = (timeout, context) => {
		context.upgradTimer = setTimeout(() => {
			context.state = 2
			$topProgress.start()

			fnPendingUpgradeToHeavyPrompt(heavyTrigger, context, '_GLOBAL_')
		}, timeout)
	}

	/**
	 * @param timeout { number } 计时器触发时长
	 * @param context { typeof loadingContext } 加载器上下文
	 * @param target { string }
	 */
	let fnPendingUpgradeToHeavyPrompt = (timeout, context, target) => {
		context.upgradTimer = setTimeout(() => {
			context.state = 3
			if (target === '_GLOBAL_') {
				$comp.trickleSpeed = 500
				context.loading = Loading.service({
					lock: true,
					// text: '网络请求失败，请刷新重试...'
				})
			} else {
				context.loading = Loading.service({
					lock: true,
					// target: target,
					fullscreen: false
				})
			}
		}, timeout)
	}

	if (lContext.upgradTimer) {
		clearTimeout(lContext.upgradTimer)
	}

	switch (lContext.state) {
		case 0:
		case 1:
			if (canLightPrompt) {
				fnPendingUpgradeToLightPrompt(lightTrigger, lContext)
			} else {
				fnPendingUpgradeToHeavyPrompt(lightTrigger, lContext, target)
			}
			break
		case 2:
			$comp.trickleSpeed += 20
			fnPendingUpgradeToHeavyPrompt(heavyTrigger, lContext, target)
			break
		case 3:
			// 无法升级了
			$comp.trickleSpeed += 50
			break
	}
	lContext.counter++
}

/**
 * @param target { string? }
 * @param indicateError { boolean? }
 */
function finish(target, indicateError) {
	if (target === undefined || target === null) target = '_GLOBAL_'
	if (indicateError === undefined) indicateError = false

	/** @type { typeof loadingContext | null } */
	let lContext = null
	let updateTopProgress = false
	if (target == '_GLOBAL_') {
		lContext = loadingContext
		updateTopProgress = true
	} else {
		lContext = loadingContext.targets[target]
	}

	lContext.counter--

	switch (lContext.state) {
		case 0:
		case 1:
			break
		case 2:
			$comp.trickleSpeed -= 20
			break
		case 3:
			$comp.trickleSpeed -= 50
			break
	}

	if (lContext.counter === 0) {
		if (lContext.upgradTimer != null) {
			clearTimeout(lContext.upgradTimer)
			lContext.upgradTimer = null
		}

		if (updateTopProgress) {
			if (indicateError) {
				$topProgress?.fail()
			} else {
				$topProgress?.done()
			}
			$comp.trickleSpeed = 250
		}

		if (lContext.loading != null) {
			lContext.loading.close()
			lContext.loading = null
		}

		lContext.state = 0
	}
}

function fail(target, message) {
	finish(target, true)

	if (message) {
		Message({
			message: message,
			type: 'error',
			duration: ERROR_MESSAGE_DURATION
		})
	}
}

export default {
	data() {
		return {
			trickleSpeed: 250,
			maxTopProgress: 90
		}
	},
	components: {
		'vue-topprogress': vueTopprogress
	},
	mounted() {
		$topProgress = this.$refs.topProgress
		$comp = this
	}
}

export const reqfb = {
	start,
	finish,
	fail
}
</script>
